export default "__VITE_ASSET__D869xpDm__"